<template>
    <div>
        <div v-if="!items || !items.length" class="bg-gray-100 h-100 w-100 rounded-lg d-flex align-items-center justify-content-center">
            <div class="text-muted text-uppercase">
                No Items This Period
            </div>
        </div>
        <div 
            v-for="item in items"
            :key="item.id"
            class="scorecard-item rounded bg-white overflow-hidden mb-2 px-3 py-2 d-flex justify-content-between"
        >
            <div class="">
                <div class="mb-2">
                    <span v-if="systemData.item_name" class="font-weight-500 font-size-80 text-uppercase text-muted mr-2">{{ systemData.item_name }}:</span>
                    <b-link v-if="getItemUrl(item)" :href="getItemUrl(item)" target="_blank" class="font-weight-bold text-decoration-none">{{ item.name }}</b-link>
                    <span v-else class="font-weight-bold">{{ item.name }}</span>
                </div>
                <p class="mb-2 text-muted small">{{ formatDate(item.timestamp) }}</p>
            </div>
            <div class="d-flex flex-column align-items-end">
                <div class="mb-1 text-center">
                    <span class="chip mb-0" :class="'chip-' + item.rule.color_variant">{{ item.rule.name }}</span>
                </div>
                <div class="text-center">
                    <div class="font-size-130 font-weight-bold text-muted">{{ item.points }}</div>
                    <div class="font-size-70 text-uppercase font-weight-500 text-muted">{{ systemData.points_name || 'Points' }}</div> <!-- change Points to SCS.points_name when you add it -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { currentUserInfoMixin } from '../../js/custom-vue-mixins';
import { FormatDateHelper } from '../../js/filters-helpers';

export default {
    name: 'ScorecardItemList',
    components: {
    },
    mixins: [
        currentUserInfoMixin,
    ],
    props: {
        systemData: { // data object for the scorecard system
            type: Object,
            required: true,
        },
        items: {  // array of items, already in the correct order for display 
            type: Array,
            required: true,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            // 
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        formatDate(value) {
            return FormatDateHelper(value);
        },
        getItemUrl(item) {
            // return the internal_url or external_url depending on currentUserInfo
            return this.$currentUserInfo.is_internal ? item.internal_url : item.external_url;
        },
    }
}
</script>

<style lang="scss">

.supplier-scorecard {
    .p-knob-text {
        font-weight: 700;
    }
    .scorecard-item {
        border: 1px solid var(--gray-200);
        border-left: 5px solid var(--gray-600);
    }
}

</style>